// extracted by mini-css-extract-plugin
export default {"w-full":"Chart_w-full__ws283","chart":"Chart_chart__pkWe7"};